import type { ReactElement } from 'react';
import Page403 from '../statusPages/Page403';
import useAuthorization from './authorizationService';
import { Permission } from './utils';

const GlobalSecurityContext = ({
  children,
  permissionToCheck,
}: {
  children: ReactElement;
  permissionToCheck: Permission | Permission[];
}) => {
  const { isGranted } = useAuthorization();

  if (!isGranted(permissionToCheck)) {
    return <Page403 />;
  }

  return children;
};

export default GlobalSecurityContext;
